export default {
    transactions_result_title: 'Resultados - Transacciones',
    transactions_result_created: 'Creado',
    transactions_result_transaction: 'Transacción Id',
    transactions_result_status: 'Estado',
    transactions_result_type: 'Tipo',
    transactions_result_message: 'Mensaje de Error',
    transactions_result_data: 'Datos',
    transactions_result_created_by: 'Creado Por',
    transactions_result_duplicated_device: "Dispositivo Duplicado",
    transactions_result_success: "Éxito",
    transactions_result_failure: "Error",
    transactions_result_pending: "Pendiente",
    transactions_result_show_data: 'Mostrar Datos',
};